






















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';

// Shared types
import { Company, Link } from '@coldtec/cos-types';

// Tool types
import { SVGIcon } from '@/types';

// Store types
import { CompanyGetter } from '@/store/store.types';

// Modal
import Modal from '@/components/modal/Modal.vue';

/**
 *  Holding the details of a social to render.
 */
interface Social {
    /** The name of the social. */
    name: string;

    /** The title for the social button. */
    title: string | null;

    /** The url of the social. */
    url: string;

    /** The icon of the social. */
    icon: SVGIcon
}

/**
 *  Holding the details of the videos' section of the modal.
 */
interface Videos {
    /** Url of the video to show in the modal. */
    modal: string | null;

    /** Url of the page where all videos can be shown. */
    all: string | null;
}

/**
 *  Modal that is shown to the user if his request was succesfully sent.
 */
@Component
export default class PersonalDetailsRequestedModal extends Vue {

    @Ref('modal')
    private modal!: Modal;

    /**
     *  Holding the paragraph of text to render.
     */
    private paragraph = '';

    /**
     *  Holding the steps to render.
     */
    private steps: Array<string> = [];

    /**
     *  Holding the socials to render.
     */
    private socials: Array<Social> = [];

    /**
     *  Holding the videos data.
     */
    private videos: Videos = {
        modal: null,
        all: null,
    };

    /**
     *  Holding the icon paths of the supported socials.
     */
    private socialIcons: { [name: string]: SVGIcon } = {
        facebook: {
            width: 13,
            height: 23,
            path: '<path d="M8.942 0c-3.18 0-5.357 1.905-5.357 5.405v3.018H0v4.101h3.585V23h4.313V12.523h3.598l.539-4.101H7.897V5.811c0-1.185.335-1.992 2.065-1.992h2.193V.161l-.05-.006h0l-.059-.007h0L11.98.141h0l-.056-.006h0l-.103-.01h0l-.114-.01h0l-.126-.011h0l-.108-.009h0l-.175-.013h0l-.156-.011h0l-.165-.01h0l-.138-.008h0l-.18-.01h0l-.112-.005h0l-.153-.007h0l-.118-.005h0l-.12-.005h0l-.122-.004h0L9.867.013h0L9.74.01h0L9.611.007h0L9.48.005h0L9.347.003h0L9.169.001h0L9.033 0h0-.091 0z" />',
        },
        instagram: {
            width: 20,
            height: 20,
            path: '<path d="M14.158 0c1.554.078 3.078.499 4.211 1.632 1.099 1.099 1.536 2.593 1.626 4.116l.005.094v8.316l-.005.094c-.09 1.523-.528 3.017-1.626 4.116-1.052 1.052-2.443 1.491-3.882 1.61l-.094.007-.094.006-.141.008H5.842l-.141-.008-.094-.006-.094-.007c-1.438-.119-2.829-.558-3.882-1.61-.974-.974-1.428-2.259-1.582-3.6l-.01-.094L0 14.158V5.842c.078-1.555.51-3.089 1.632-4.211C2.684.58 4.075.141 5.513.022l.094-.007.094-.006L5.842 0h8.316zM9.909 1.853h-.396l-.496.001-.419.002-.41.003-.465.004-.383.004-.367.005-.404.007-.323.007-.251.006-.048.001-.075.002-.075.003-.189.012-.076.006-.446.055-.081.014c-.77.137-1.526.437-2.058 1.012-.77.832-1.067 1.834-1.104 2.955l-.002.078-.004.175-.005.272-.004.3-.004.422-.003.563-.002.49-.001.567.001.951.004 1.244.006 1.141L1.842 14c.034 1.139.325 2.157 1.105 3 .603.651 1.491.95 2.363 1.058l.076.009.524.037.085.002.251.006.323.007.286.005.361.005.508.006.33.003.407.003.556.003.567.002h.325.578l.496-.001.419-.002.41-.003.465-.004.383-.004.367-.005.404-.007.323-.007.251-.006.048-.001.075-.002.075-.003.189-.012.076-.006.446-.055.081-.014c.77-.137 1.526-.437 2.058-1.012.78-.843 1.075-1.861 1.105-3V6c-.03-1.139-.325-2.157-1.105-3-.603-.651-1.491-.95-2.363-1.058l-.076-.009-.113-.012-.075-.007-.299-.018-.074-.002-.196-.005-.207-.005-.331-.007-.352-.006-.433-.006-.388-.004-.401-.003-.481-.003-.421-.002-.355-.001h-.578zM10 4.675c2.91 0 5.268 2.384 5.268 5.325 0 1.412-.555 2.767-1.543 3.765A5.24 5.24 0 0 1 10 15.325c-2.91 0-5.268-2.384-5.268-5.325S7.09 4.675 10 4.675zm0 1.89c-1.877 0-3.399 1.538-3.399 3.435S8.123 13.435 10 13.435s3.399-1.538 3.399-3.435S11.877 6.565 10 6.565zm5.291-2.92a1.06 1.06 0 0 1 1.054 1.065 1.07 1.07 0 0 1-.309.753 1.05 1.05 0 0 1-.745.312 1.06 1.06 0 0 1-1.053-1.065 1.06 1.06 0 0 1 1.054-1.065z" />',
        },
        linkedin: {
            width: 16,
            height: 16,
            path: '<path d="M0 4.571h3.048V16H0V4.571zm1.515-1.524h-.017C.588 3.048 0 2.37 0 1.523 0 .658.606 0 1.532 0S3.03.658 3.048 1.523c0 .846-.588 1.525-1.533 1.525zM16 8.762a4.19 4.19 0 0 0-4.19-4.19c-1.419 0-2.67.707-3.429 1.786V4.571H5.333V16h3.048V9.905c0-1.262 1.023-2.286 2.286-2.286s2.286 1.023 2.286 2.286V16H16V8.762z"/>',
        },
        youtube: {
            width: 18,
            height: 13,
            path: '<path d="M1.824.432c4.63-.575 9.314-.575 13.945 0 .76.099 1.485.838 1.578 1.608a35.94 35.94 0 0 1 0 8.383c-.092.77-.818 1.51-1.578 1.608-4.631.575-9.315.575-13.945 0-.76-.098-1.486-.838-1.578-1.608-.327-2.823-.327-5.56 0-8.383.092-.77.818-1.509 1.578-1.608zM7.33 3.299v5.864l4.398-2.932L7.33 3.299z" fill-rule="evenodd" />',
        },
    };

    /**
     *  Used to get the company for which the modal is shown.
     */
    private get company(): Company {

        return this.$store.getters[CompanyGetter.DETAILS];

    }

    /**
     *
     *  Used to get the width of the modal.
     *
     *  (i) We're decreasing the size of no video is shown
     *
     */
    private get width(): string {

        return this.videos.modal ? '50rem' : '30rem';

    }

    /**
     *  Used to open the modal.
     */
    public open(): void {

        this._setContent();

        this.modal.open();

    }

    /**
     *  Used to open the forwarded url in a new window or tab.
     */
    private openUrl(url: string): void {

        window.open(url, '_blank')?.focus();

    }

    /**
     *  Used to set all the content that is rendered in the modal,
     *  based on the company for which the modal is shown.
     */
    private _setContent(): void {

        this._setParagraph();
        this._setSteps();
        this._setSocials();
        this._setVideos();

    }

    /**
     *  Used to set the paragraph that is shown.
     */
    private _setParagraph(): void {

        this.paragraph = 'Heeft u zich heerlijk gekleed op het weer, zit u de hele dag binnen omdat u een airco via Coldtec hebt. We danken u hartelijk voor de tijd en moeite die u in het duidelijke offerte traject hebt gestoken. We behandelen uw aanvraag binnen 5 werkdagen.';

    }

    /**
     *  Used to set the steps that companies' going
     *  to take after recieving the request.
     */
    private _setSteps(): void {

        this.steps = [
            'We nemen telefonisch contact met u op om de situatie te bespreken en eventueel een bezoek in te plannen.',
            'Door middel van een bezoek of het contact komt er een specifieke offerte voor uw situatie.',
            'U geeft akkoord en wij monteren met veel plezier en vrolijkheid de juiste airco bij u thuis.',
        ];

    }

    /**
     *  Used to construct the socials to render.
     */
    private _setSocials(): void {

        this._forEachLink((link: Link) => {

            /**
             *  Only socials that have an icon defined are supported.
             */
            const icon: SVGIcon | undefined = this.socialIcons[link.key];

            if (icon) {

                this.socials.push({
                    name: link.key.charAt(0).toUpperCase() + link.key.slice(1),
                    title: link.name,
                    url: link.link,
                    icon,
                });

            }


            return true;

        });

    }

    /**
     *  Used to set the link of the video that should be shown
     *  in the modal `videos.modal` and the link of the
     *  button that navigates the user to all videos.
     */
    private _setVideos(): void {

        this._forEachLink((link: Link) => {

            if (link.key === 'videos.modal') {

                this.videos.modal = link.link;

            }

            if (link.key === 'videos.all') {

                this.videos.all = link.link;

            }

            return !(this.videos.modal && this.videos.all);

        });

    }

    /**
     *
     *  Small util to loop through each link of the company.
     *
     *  (i) Return `false` to stop the loop
     *
     *  @param cb The callback to invoke for each link
     *
     */
    private _forEachLink(cb: (link: Link) => boolean): void {

        ((this.company.links || []) as Array<Link>).every((link: Link) => {

            return cb(link);

        });

    }

}
